async function loadSVGSprite(path)
{
  try
  {
    const response = await fetch(path);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

    const svgText = await response.text();

    // Create a hidden container for the sprite
    const container = document.createElement('div');
    container.id = 'svg-sprite-container';
    container.style.display = 'none';
    container.innerHTML = svgText;

    // Prepend to body so it's available globally
    document.body.insertBefore(container, document.body.firstChild);

    console.log('SVG Sprite loaded successfully.');
  }
  catch (error)
  {
    console.error('Failed to load SVG sprite:', error);
  }
}

export async function inlineSvgSprites(fileName)
{
  try
  {
    if (fileName?.endsWith('.svg'))
    {
      await loadSVGSprite(fileName);
    }
  }
  catch (error)
  {
    console.error('Failed to inline Icons', error);
  }
}
